import React, { useEffect, useState } from "react";

import Table from "react-bootstrap/Table";
import { Link } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';


import "../Home/styles.css";

import { api } from "../../services/api";
import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutListCourse } from "../../components/DashLayoutListCourse";

import CircularProgress from "@mui/material/CircularProgress";

export const CourseDispOn = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const courseList = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };
      const res = await api.get("/curso/lista", httpOptions);
      setList(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    courseList();
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, [setList]);

  return (
    <>
      <Header />
      <Menu />
      <DashLayoutListCourse>

      <h3 style={{ color: "#F33131", marginTop: '-5rem' }}>{_data.nome}</h3>
<br />
        <h3 style={{ color: "#ccc" }}>MEUS CURSOS</h3>
        <hr style={{ color: "#ccc" }} />
        {isLoading !== false ? (
          <>
            <br />{" "}
            <center>
              <h4 style={{ color: "#568989" }}>Carregando.... </h4>
              <br />
              <CircularProgress />
            </center>
          </>
        ) : (
          <>
            {list.length > 0 ? (
              <>
                {" "}
                <br />
                <Table variant="dark" responsive="xl">
                  <thead style={{ border: "none" }}>
                    <tr>
                      <th>#</th>
                      <th>Cod.</th>
                      <th>Curso</th>
                      <th>Modalidade</th>
                      <th>Situação do Curso</th>
                      <th>Certificado</th>

                    </tr>
                  </thead>

                  <tbody>
                    {list.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>

                          <td>{item.codigo}</td>
                          <td>{item.nome}</td>
                          <td>
                            {item.modalidade === "1" ? "EAD" : "PRESENCIAL"}
                          </td>
                          {item.modalidade === "3" ? (
                            <>
                              <td style={{ width: "20vh", color: "GREEN" }}>
                                {" "}
                                EXECUÇÃO{" "}
                              </td>
                            </>
                          ) : (
                            <>
                              <td style={{ width: "20vh", color: "RED" }}>
                                {" "}
                                REALIZADO{" "}
                              </td>
                            </>
                          )}
          <td>
    <Link to={`https://sesat1.sefaz.pb.gov.br/esat/certificados/admPDFDeclaracaoPECParticip.php?p=${item.idpec}&n=${_data.sq}`} target="_blank" style={{ textDecoration: 'none', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <FaEye />
    </Link>
</td>

                          <br />
                        </tr>
                      );
                    })}
                  </tbody>
                  <tbody>
                    <tr>
                      <td> Total:</td>
                      <td> {list.length} </td>
                    </tr>
                  </tbody>
                </Table>
              </>
            ) : (
              <>
                <center>
                  <h4 style={{ color: "#898282" }}>
                    {" "}
                    Você não tem nenhum curso realizado na ESAT....{" "}
                  </h4>
                  <br />
                </center>
              </>
            )}
          </>
        )}

        <br />
      </DashLayoutListCourse>
      <Rodape />
    </>
  );
};
